module.exports = __webpack_public_path__ + "static/media/navLogo.1c09eccf.png";